// navigator.vibrate is a real haptic on Android Chrome; iOS Safari ignores it.
// Cheap fallback for both — never crashes if unsupported.
const buzz=(ms=10)=>{try{navigator.vibrate&&navigator.vibrate(ms);}catch{}};

export default function ConfirmDialog({text,onYes,onNo}){
  const handleYes=()=>{buzz(10);onYes&&onYes();};
  const handleNo=()=>{buzz(10);onNo&&onNo();};
  return<div className="confirm-overlay" onClick={handleNo}><div className="confirm-box" onClick={e=>e.stopPropagation()}><div className="confirm-text">{text}</div><div className="confirm-actions"><button className="confirm-no" onClick={handleNo}>Cancel</button><button className="confirm-yes" onClick={handleYes}>Yes</button></div></div></div>;
}
